// import { Component } from '@angular/core';
// import {
//   FormBuilder,
//   Validators,
//   AbstractControl,
//   FormGroup,
// } from '@angular/forms';
// import { ReactiveFormsModule } from '@angular/forms';
// import { Router, RouterModule } from '@angular/router';
// import { CommonModule } from '@angular/common';
// import { AuthService } from '../../_services/auth.service';
// import { ToastService } from '../../_services/toast.service';

// @Component({
//   selector: 'app-forgot-password',
//   imports: [ReactiveFormsModule, CommonModule, RouterModule],
//   templateUrl: './forgot-password.component.html',
//   styleUrl: './forgot-password.component.scss',
// })
// export class ForgotPasswordComponent {
//   step = 1;
//   loading = false;

//   emailForm!: FormGroup;
//   otpForm!: FormGroup;
//   passwordForm!: FormGroup;
//   userDetail: any = null;
//   constructor(
//     private fb: FormBuilder,
//     private _AS: AuthService,
//     private _NS: ToastService,
//     private router: Router
//   ) {}

//   ngOnInit(): void {
//     this.initForms();
//   }

//   private initForms() {
//     this.emailForm = this.fb.group({
//       phone: ['', [Validators.required]],
//     });

//     this.otpForm = this.fb.group({
//       otp: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
//     });

//     this.passwordForm = this.fb.group(
//       {
//         password: ['', [Validators.required, Validators.minLength(6)]],
//         confirmPassword: ['', Validators.required],
//       },
//       { validators: this.passwordMatchValidator }
//     );
//   }

//   passwordMatchValidator(group: AbstractControl) {
//     const pass = group.get('password')?.value;
//     const confirm = group.get('confirmPassword')?.value;
//     return pass === confirm ? null : { mismatch: true };
//   }

//   get phone() {
//     return this.emailForm.get('phone');
//   }
//   get otp() {
//     return this.otpForm.get('otp');
//   }

//   sendOtp() {
//     if (this.emailForm.invalid) return;
//     this.loading = true;
//     this.userDetail = null;
//     this._AS.forgotPWS(this.emailForm.value).subscribe({
//       next: (res: any) => {
//         this.loading = false;
//         if (res.message === 'SSR mode') {
//           return;
//         }

//         if (res.status) {
//           this._NS.success(res.message);
//           this.userDetail = res.data;
//           setTimeout(() => {
//             this.loading = false;
//             this.step = 2;
//           }, 1000);
//         } else {
//           this._NS.error(res.message);
//         }
//       },
//       error: (error) => {
//         this.loading = false;
//         let errorMessage = null;
//         if (error.status === false) {
//           errorMessage = error.message;
//         } else {
//           errorMessage =
//             'Login failed. Please check your credentials and try again.';
//         }
//         this._NS.error(errorMessage);
//       },
//     });
//   }

//   verifyOtp() {
//     if (this.otpForm.invalid) return;
//     this.loading = true;
//     let data = {
//       userId: this.userDetail.id,
//       ...this.otpForm.value,
//     };
//     this._AS.verifyOtpPws(data).subscribe({
//       next: (res: any) => {
//         this.loading = false;
//         if (res.message === 'SSR mode') {
//           return;
//         }
//         if (res.status) {
//           this._NS.success(res.message);
//           setTimeout(() => {
//             this.loading = false;
//             this.step = 3;
//           }, 1000);
//         } else {
//           this._NS.error(res.message);
//         }
//       },
//       error: (error) => {
//         this.loading = false;
//         let errorMessage = null;
//         if (error.status === false) {
//           errorMessage = error.message;
//         } else {
//           errorMessage =
//             'Login failed. Please check your credentials and try again.';
//         }
//         this._NS.error(errorMessage);
//       },
//     });
//   }

//   resetPassword() {
//     if (this.passwordForm.invalid) return;
//     this.loading = true;
//     let data = {
//       id: this.userDetail.id,
//       password: this.passwordForm.value.password,
//       c_password: this.passwordForm.value.confirmPassword,
//     };
//     this._AS.updatePWS(data).subscribe({
//       next: (res: any) => {
//         this.loading = false;
//         if (res.message === 'SSR mode') {
//           return;
//         }
//         if (res.success) {
//           this.loading = false;
//           this._NS.success(res.message);
//           this.router.navigate(['/login']);
//         } else {
//           this._NS.error(res.message);
//         }
//       },
//       error: (error) => {
//         this.loading = false;
//         let errorMessage = null;
//         if (error.status === false) {
//           errorMessage = error.message;
//         } else {
//           errorMessage =
//             'Login failed. Please check your credentials and try again.';
//         }
//         this._NS.error(errorMessage);
//       },
//     });
//   }

//   resendOtp() {
//     alert('OTP resent');
//   }
// }

import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import {
  FormBuilder,
  Validators,
  AbstractControl,
  FormGroup,
} from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../_services/auth.service';
import { ToastService } from '../../_services/toast.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-6px)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-6px)' }))
      ])
    ])
  ]
})
export class ForgotPasswordComponent implements OnInit {
  step = 1;
  loading = false;

  emailForm!: FormGroup;
  otpForm!: FormGroup;
  passwordForm!: FormGroup;
  userDetail: any = null;

  // ─── Country code ─────────────────────────────────────────────────────────
  selectedCountry = { name: 'India', dial: '+91', code: 'IN', flag: '🇮🇳' };
  countries: any[] = [];
  dropdownOpen = false;
  searchQuery = '';

  constructor(
    private fb: FormBuilder,
    private _AS: AuthService,
    private _NS: ToastService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.getCode();
  }

  // ─── Forms ────────────────────────────────────────────────────────────────

  private initForms() {
    this.emailForm = this.fb.group({
      phone: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(50)]],
      country: [''],
    });

    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
    });

    this.passwordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(group: AbstractControl) {
    const pass = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pass === confirm ? null : { mismatch: true };
  }

  // ─── Getters ──────────────────────────────────────────────────────────────

  get phone() { return this.emailForm.get('phone'); }
  get otp()   { return this.otpForm.get('otp'); }

  // ─── Country code ─────────────────────────────────────────────────────────

  getCode() {
    this._AS.getCountryCode().subscribe((res: any) => {
      this.countries = res;
      this.selectedCountry = this.countries.find((c: any) => c.code === 'IN')!;
      this.emailForm.patchValue({ country: this.selectedCountry });
    });
  }

  get filteredCountries() {
    const q = this.searchQuery.toLowerCase();
    return this.countries.filter(
      (c: any) => c.name.toLowerCase().includes(q) || c.dial.includes(q)
    );
  }

  isPhoneInput(): boolean {
    const val = this.emailForm.get('phone')?.value || '';
    return /^[\d\s\-()+]+$/.test(val) && !/[@.]/.test(val) && val.length > 0;
  }

  onAuthInput(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    const isPhone = /^[\d\s\-()+]+$/.test(input) && !/[@.]/.test(input);

    if (isPhone && input.length > 0) {
      if (!input.startsWith(this.selectedCountry.dial)) {
        this.emailForm.patchValue(
          // { phone: `${this.selectedCountry.dial}${input.replace(/^\+?\d{1,4}[-\s]?/, '')}` },
          { phone: `${input}` },
          { emitEvent: false }
        );
      }
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectCountry(country: any) {
    const currentPhone: string = this.emailForm.get('phone')?.value || '';
    if (currentPhone.startsWith(this.selectedCountry.dial)) {
      const numberOnly = currentPhone.slice(this.selectedCountry.dial.length);
      this.emailForm.patchValue(
        { phone: `${numberOnly}` },
        { emitEvent: false }
      );
    }
    this.selectedCountry = country;
    this.dropdownOpen = false;
    this.searchQuery = '';
    this.emailForm.patchValue({ country });
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(e: Event) {
    if (!this.el.nativeElement.contains(e.target)) this.dropdownOpen = false;
  }

  // ─── Step 1: Send OTP ─────────────────────────────────────────────────────

  sendOtp() {
    if (this.emailForm.invalid) return;
    this.loading = true;
    this.userDetail = null;

    const payload = {
      phone: this.emailForm.value.phone,
      country: this.emailForm.value.country,
    };

    this._AS.forgotPWS(payload).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.message === 'SSR mode') return;
        if (res.status) {
          this._NS.success(res.message);
          this.userDetail = res.data;
          setTimeout(() => { this.step = 2; }, 1000);
        } else {
          this._NS.error(res.message);
        }
      },
      error: (error) => {
        this.loading = false;
        this._NS.error(
          error.status === false
            ? error.message
            : 'Request failed. Please try again.'
        );
      },
    });
  }

  // ─── Step 2: Verify OTP ───────────────────────────────────────────────────
  verifyUser:any
  verifyOtp() {
    if (this.otpForm.invalid) return;
    this.loading = true;
    const data = { userId: this.userDetail._id, ...this.otpForm.value };

    this._AS.verifyOtpPws(data).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.message === 'SSR mode') return;
        if (res.status) {
          this.verifyUser = res.data
          this._NS.success(res.message);
          setTimeout(() => { this.step = 3; }, 1000);
        } else {
          this._NS.error(res.message);
        }
      },
      error: (error) => {
        this.loading = false;
        this._NS.error(
          error.status === false
            ? error.message
            : 'OTP verification failed. Please try again.'
        );
      },
    });
  }

  // ─── Step 3: Reset Password ───────────────────────────────────────────────

  resetPassword() {
    if (this.passwordForm.invalid) return;
    this.loading = true;
    const data = {
      id: this.verifyUser._id ?? this.userDetail._id ,
      password: this.passwordForm.value.password,
      c_password: this.passwordForm.value.confirmPassword,
    };

    this._AS.updatePWS(data).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.message === 'SSR mode') return;
        if (res.success) {
          this._NS.success(res.message);
          this.router.navigate(['/login']);
        } else {
          this._NS.error(res.message);
        }
      },
      error: (error) => {
        this.loading = false;
        this._NS.error(
          error.status === false
            ? error.message
            : 'Password reset failed. Please try again.'
        );
      },
    });
  }

  // ─── Resend OTP ───────────────────────────────────────────────────────────

  resendOtp() {
    this.sendOtp();
  }
}
